var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !(_vm.favouritesError || _vm.favouritesLoading)
    ? _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: {
                content: _vm.isFavourite
                  ? "Remove From Favourites"
                  : "Favourite Colour",
                offset: 5,
                placement: "right",
                classes: "tooltip--simple-theme hidden! md:block!",
                hideOnTargetClick: false,
                container: this.$el,
                show: _vm.isTooltipVisible,
                trigger: "manual",
              },
              expression:
                "{\n    content: isFavourite ? 'Remove From Favourites' : 'Favourite Colour',\n    offset: 5,\n    placement: 'right',\n    classes: 'tooltip--simple-theme hidden! md:block!',\n    hideOnTargetClick: false,\n    container: this.$el,\n    show: isTooltipVisible,\n    trigger: 'manual',\n  }",
            },
          ],
          staticClass: "block w-9 h-9 focus:outline-none",
          attrs: { type: "button" },
          on: {
            mouseenter: _vm.handleMouse,
            mouseleave: _vm.handleMouse,
            click: function ($event) {
              _vm.isFavourite
                ? _vm.removeFavourite(_vm.selectedColour)
                : _vm.addFavourite(_vm.selectedColour)
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "w-full h-full p-2px",
              attrs: { viewBox: "0 0 29 29", fill: "none" },
            },
            [
              _c("path", {
                staticClass: "transition duration-300",
                attrs: {
                  d: "M14.4468 22.3077C16.7507 20.1102 19.0792 18.0078 21.2565 15.7692C22.798 14.183 22.5864 11.6691 21.0001 10.1476C19.3904 8.60555 16.847 8.50837 15.1084 9.92188C14.5196 10.4013 14.4636 10.4013 13.8927 9.93484C12.1229 8.49001 9.50781 8.60987 7.92042 10.2102C6.33639 11.8051 6.25579 14.3309 7.84766 15.9269C10.006 18.0898 12.2404 20.1815 14.4468 22.3077Z",
                  fill: _vm.fillColour,
                  stroke: _vm.strokeColour,
                  "stroke-miterlimit": "10",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                staticClass: "transition duration-300",
                attrs: {
                  cx: "14.5",
                  cy: "14.5",
                  r: "14",
                  stroke: _vm.strokeColour,
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.isFavourite ? "Remove" : "Add") + " Favourite"),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }